/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentDates/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AppointmentDates({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/AppointmentDates",
  onChange
  
}) {
let settingsSkipMonthIfNoSlotsValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'skipMonthIfNoSlots',
})
let settingsSkipMonthIfNoSlotsChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'skipMonthIfNoSlots',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let settingsAppointmentSlotOffsetDaysValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'appointmentSlotOffsetDays',
format: fromHelpers.getValue,
})
let settingsAppointmentSlotOffsetDaysChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'appointmentSlotOffsetDays',
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={dtSpaceS}
 data="settings.skipMonthIfNoSlots"
 value={settingsSkipMonthIfNoSlotsValueData}
 onChange={settingsSkipMonthIfNoSlotsChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 paddingTop={0}
 paddingBottom={0}
 paddingRight={0}
 paddingLeft={0}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 marginLeft={dtSpaceXs}
 text="Skip current month if no appointments available"
/>
</React.Fragment>
)}
</TysiaToggle>
<div
  data-testid="AppointmentDates.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AppointmentDates.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Patients can schedule appointments"
/>
</div>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginRight={5}
 allowEmptyChoice={false}
 data="options"
 from={optionsValueData}
 data="settings.appointmentSlotOffsetDays"
 format="helpers.js getValue"
 value={settingsAppointmentSlotOffsetDaysValueData}
 onChange={settingsAppointmentSlotOffsetDaysChangeData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 width={100}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
<div
  data-testid="AppointmentDates.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="day(s) from the day they are booking"
/>
</div>
</div>
<div
  data-testid="AppointmentDates.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 size="small"
 fontStyle="italic"
 color={dtColorsNeutral600}
 text="For example, enter 0 to allow same day bookings, 1 to allow next-day bookings, etc."
/>
</div>
{children}
</React.Fragment>)
}